import styled from 'styled-components';

export const Legend = styled.legend`
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 15px;
`;
